// import isCommercialMiddleware from '@/router/middlewares/isCommercialMiddleware';
// import RepresentativeEdit from '_modules/representative/views/RepresentativeEdit.vue';
import RepresentativeList from '_modules/representative/views/RepresentativeList.vue';
import Representative from './Root.vue';


export default {
  path: 'representantes/',
  component: Representative,
  name: 'admin-representative',
  redirect: '/representantes/lista/1',
  children: [
    {
      // beforeEnter: isCommercialMiddleware,
      path: 'lista/:page',
      name: 'admin-representative-list',
      component: RepresentativeList,
    },
    // {
    //   path: 'perfil',
    //   name: 'admin-representative-perfil',
    //   component: RepresentativeEdit,
    // },
  ],
};
